@if (!editMode) {
  <div class="inlineEditorContainer inlineTextArea" >
    @if (label) {
      <span class="inline-text-label">
        {{label}}
      </span>
    }
    <div
      (click)="changeToEdit($event)"
      [ngClass]="{'editable': true, 'editable-text':true, 'disabled':disabledFlag}"
      aria-label='click to edit'>{{data||placeholder}}
    </div>
  </div>
}
@if (editMode) {
  <div>
    <app-weave-input
      [data]="data"
      [label]="label"
      [placeholder]="placeholder"
      (focusOut)="onFocusOut($event)"
    ></app-weave-input>
  </div>
  }
